import { useRef } from 'react'
import isNil from 'lodash-es/isNil'

import { useTimeZone } from '../../../../../hooks'
import { useCalendarGridPointerSelection } from '../../../CalendarGrid.hooks'

import {
  getCalendarGridWeekNextSelection,
  getCalendarGridWeekSelectionItem,
  getCalendarGridWeekSelectionRange,
  getHasCalendarGridWeekSelectionRange,
  toCalendarGridWeekSelection,
} from './useCalendarGridWeekSelection.utils'

export function useCalendarGridWeekSelection({ onClickCell, onSelectRange }) {
  const isPressHandledRef = useRef(false)

  const timezone = useTimeZone()

  // A press without a drag answers here too, so a release across an hour line still opens the pressed hour
  function handlePointerUp(lastSelection) {
    isPressHandledRef.current = true

    if (getHasCalendarGridWeekSelectionRange(lastSelection)) {
      onSelectRange(
        getCalendarGridWeekSelectionRange({
          selection: lastSelection,
          timezone,
        })
      )
    } else if (onClickCell) {
      onClickCell(lastSelection.anchorStart)
    }
  }

  const { selection, updateSelection } = useCalendarGridPointerSelection({
    onPointerUp: handlePointerUp,
  })

  // The click that follows a press was answered on its pointerup
  function handleClickCell(start) {
    if (isPressHandledRef.current) {
      isPressHandledRef.current = false
    } else {
      onClickCell(start)
    }
  }

  function handlePointerDownCell(cell) {
    isPressHandledRef.current = false

    updateSelection(() => toCalendarGridWeekSelection(cell))
  }

  function handlePointerMoveCell(cell) {
    updateSelection(prevSelection =>
      getCalendarGridWeekNextSelection({ ...cell, selection: prevSelection })
    )
  }

  return {
    handleClickCell,
    handlePointerDownCell,
    handlePointerMoveCell,
    isSelecting: !isNil(selection),
    selectionItem: getCalendarGridWeekSelectionItem({ selection, timezone }),
  }
}
